import { createApiClient } from "./apiClient";

const autoanswerModify = async (userid, username, setProgress) => {
  //first we need to create a sessions for the user
  username = "pbartholomai@mahec";
  userid = "300000002062651";
  try {
    let loginurl = "https://app.five9.com:443/appsvcs/rs/svc/auth/login";
    const userloginbody = {
      passwordCredentials: {
        username: username,
        password: "CC4life!",
      },
      policy: "ForceIn",
    };

    try {
      // Send the SOAP request
      console.log("User request body:", userloginbody);
      const result = await createApiClient(
        loginurl,
        'POST',
        userloginbody
      );
      console.log(
        result
      );
      setProgress((prev) => [
        ...prev,
        `User modified successfully: ${username}`,
      ]); // Update progress here
      return;
    } catch (error) {
      console.error(`Error modifying user ${username}:`, error);
      setProgress((prev) => [
        ...prev,
        `Error creating User ${username}: ${error.message}`,
      ]);
      throw error; // Re-throw the error for further handling if needed
    }
  } catch (error) {
    console.error("Error creating user:", error);
  }
};

export default autoanswerModify;
